export default "__VITE_ASSET__B$naCMcZ__"